<div fxLayout=row fxLayoutAlign="space-around center">

  
  <mat-card style="width: 100%">
          <mat-card-title>
              <h3 i18n>Budget list</h3>
          </mat-card-title>
          <div class="example-header">
            
            <mat-form-field>
              <input matInput (keyup)="applyFilter($event.target.value)" [value]="getListFilter()" placeholder="Filter">
            </mat-form-field>
            <mat-slide-toggle [checked]="showExport" (change)="applyShowExport($event)">Show export</mat-slide-toggle>
            <span class="iconfilter">
              <mat-icon title="new" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'new'}" (click)="setIconFilter('new')">whatshot</mat-icon>
              <mat-icon title="assigned" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'assigned'}" (click)="setIconFilter('assigned')">person</mat-icon>
              <!--
              <mat-icon title="edit" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'edit'}" (click)="applyIconFilter('edit')">star_half</mat-icon>
              <mat-icon title="ready" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'ready'}" (click)="applyIconFilter('ready')">star</mat-icon>
              <mat-icon title="approved" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'approved'}" (click)="applyIconFilter('approved')">check</mat-icon>
              -->
              <mat-icon title="underway" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'closed'}" (click)="setIconFilter('closed')">loop</mat-icon>
              <mat-icon title="archived" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'archived'}" (click)="setIconFilter('archived')">archived</mat-icon>
              <!-- <mat-icon title="warning" class="icons" [ngClass]="{'icon-on': dataSource.iconFilter == 'default'}" (click)="applyIconFilter('default')">warning</mat-icon> -->
            </span>
          </div>
          
          <div class="example-container mat-elevation-z8">
          
            <mat-table [dataSource]="dataSource" matSort>
              
              <!-- Status -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Status</mat-header-cell>
                
                <mat-cell *matCellDef="let row" [ngSwitch]="row.status">
                  <mat-icon *ngSwitchCase="'new'" [title]="row.status">whatshot</mat-icon>
                  <mat-icon *ngSwitchCase="'assigned'" [title]="row.status">person</mat-icon>
                  <mat-icon *ngSwitchCase="'edit'" [title]="row.status">star_half</mat-icon>
                  <mat-icon *ngSwitchCase="'ready'" [title]="row.status">star</mat-icon>
                  <mat-icon *ngSwitchCase="'approved'" [title]="row.status">check</mat-icon>
                  <mat-icon *ngSwitchCase="'closed'" [title]="row.status">loop</mat-icon>
                  <mat-icon *ngSwitchCase="'archived'" [title]="row.status">archived</mat-icon>
                  <mat-icon *ngSwitchDefault [title]="row.status">warning</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- ProjectNr -->
              <ng-container matColumnDef="projectNr">
                  <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Project Nr.</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row | projectNr }} </mat-cell>
              </ng-container>

              <!-- ID Column -->
              <ng-container matColumnDef="budgetNr">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Budget Nr.</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.budgetNr ? row.budgetNr : row.budgetNumber }} </mat-cell>
              </ng-container>

              <!-- ID Column -->
              <ng-container matColumnDef="manager">
                  <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Project Mgr.</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.project?.projectManager?.displayName  }} </mat-cell>
                </ng-container>

              <!-- PW Name Column -->
              <ng-container matColumnDef="pwName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Opportunity Name</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.prosperworks ? row.prosperworks.name : row.description }} </mat-cell>
                </ng-container>

                <!-- PW Name Column -->
              <ng-container matColumnDef="pwCompanyName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Company Name</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.companyName ? row.companyName : row.prosperworks?.company_name }} </mat-cell>
                </ng-container>
          
              <!-- Author Column -->
              <ng-container matColumnDef="author">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Author</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ displayAuthor(row) }} </mat-cell>
              </ng-container>
          
              <!-- Category Column -->
              <ng-container matColumnDef="category">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Category</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.category }} </mat-cell>
              </ng-container>
          
              <!-- Creation Column -->
              <ng-container matColumnDef="creation">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Creation</mat-header-cell>
                <mat-cell *matCellDef="let row" [style.color]="row.color"> {{ row.creation | date }} </mat-cell>
              </ng-container>

              <!-- Delivery Column -->
              <ng-container matColumnDef="deliveryThr">
                <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Delivery Date</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.deliveryThr | date }} </mat-cell>
              </ng-container>

              <!-- Link to Balances -->
              <ng-container matColumnDef="balances">
                  <mat-header-cell *matHeaderCellDef i18n></mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <a [routerLink]="['/balances/summary/',row.id]" mat-icon-button>
                      <mat-icon>euro_symbol</mat-icon>
                    </a>
                  </mat-cell>
                </ng-container>
          
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToBudget(row)">
              </mat-row>
            </mat-table>
          
            <mat-paginator [length]="dataSource.resultsLength" pageSize="100" [pageSizeOptions]="[5, 10, 25, 100, 500]"></mat-paginator>
          </div>
      </mat-card>
</div>


// WEBPACK FOOTER //
// ./src/app/budget/budget-list.component.html